import React from "react";

import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import { cn } from "@/utils/general";

export interface FaqDisclaimerProps {
  className?: string;
}

const FaqDisclaimer: React.FC<FaqDisclaimerProps> = ({ className }) => {
  const copyrightYear = new Date().getFullYear();
  const iqviaDate = process.env.NEXT_PUBLIC_IQVIA_DATE;

  return (
    <div className={cn(className)}>
      <TextElement element="p" className="body--small text-master-base-alt-disabled">
        © {copyrightYear} Nutraceutical Wellness Inc. All Rights Reserved.
        <br />
        These statements have not been evaluated by the Food and Drug Administration.
        <br />
        These products are not intended to diagnose, treat, cure, or prevent any disease.
        {iqviaDate ? (
          <>
            <br />*{iqviaDate}
          </>
        ) : null}
        <br />
        **Nutrafol’s calculation based in part on data reported by NIQ through its Omnisales Service
        for the Hair Growth Supplement category for the 52-week period ending 11/30/2024 for the
        U.S. market according to Nutrafol’s custom product hierarchy. Copyright © 2025, Nielsen
        Consumer LLC.
      </TextElement>
    </div>
  );
};

export default FaqDisclaimer;
